
import {Component, Vue} from 'vue-property-decorator'

import { VImg } from 'vuetify/lib'

@Component({
  name: 'Img',
  extends: VImg as any,
})
export default class Img extends Vue {

}
